import { object, string } from "yup";
import { useState } from "react";
import Validations from "@src/utility/helpers/validations";
import useAxios from "@hooks/use-axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const useLogin = () => {
    const { axiosInstance, loading: emailLoginLoading } = useAxios({
        base              : "panel",
        alertTypeOnSuccess: "toast"
    });

    const { axiosInstance: googleAxiosInstance, loading: googleLoginLoading } = useAxios({
        base              : "panel",
        alertTypeOnSuccess: "toast"
    });

    const [activeTab, setActiveTab] = useState("viaEmail");
    const [isOpen, setIsOpen] = useState(false);
    const { requiredValidation, emailRequiredValidation } = Validations();

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const methods = useForm({
        defaultValues: {
            permissions: [],
            type       : "normal",
            email      : "",
            password   : ""
        },
        resolver: yupResolver(
            object().shape({
                email   : activeTab === "viaEmail" ? emailRequiredValidation({ name: "Email" }) : string(),
                password: activeTab === "viaEmail" ? requiredValidation({ name: "Password" }) : string()
            })
        )
    });

    const navigate = useNavigate();
    const handleModalToggle = type => {
        setIsOpen(!isOpen);
        methods.reset({ type });
    };
    // Login with Google or Admin
    const onSubmit = () => {
        methods.handleSubmit(async formData => {
            const permissions = formData.permissions || [];
            const access_email = permissions.includes("access_email");
            const access_calendar = permissions.includes("access_calendar");
            const { data } = await googleAxiosInstance.get("user/login-url", {
                headers: {
                    Authorization: `Bearer ${JSON.stringify({
                        access_email:
                                formData.type !== "admin" ? "true" : access_email ? "true" : "false",
                        access_calendar:
                                formData.type !== "admin" ? "true" : access_calendar ? "true" : "false"
                    })}`
                }
            });
            handleModalToggle("normal");
            if (data.url) {
                window.location.href = data.url;
            }

        })();
    };

    // Login with Email/Password
    const onEmailLogin = () => {
        methods.handleSubmit(async ({ email, password }) => {
            const { data } = await axiosInstance.post(
                "user/login-with-email",
                {
                    email,
                    password
                }
            );
            navigate(`/verify/two-factor-auth?verification_token=${data.verification_token}`);
    
        })();
    };

    const handleKeyPress = e => {
        if (e.keyCode === 13) {
            e.preventDefault();
            onSubmit();
        }
    };

    return {
        onSubmit,
        onEmailLogin,
        emailLoginLoading,
        googleLoginLoading,
        handleKeyPress,
        handleModalToggle,
        isOpen,
        methods,
        handleTabChange,
        activeTab
    };
};

export default useLogin;
